// ProfileSidebar.js
import React from 'react';
import { CgProfile } from 'react-icons/cg';
import { useNavigate } from 'react-router-dom';
import SignOut from '../../components/navbar/SignOut';

const ProfileSidebar = ({ activeSection, handleSectionChange, handleSignOut }) => {
  const navigate = useNavigate();

  return (
    <aside className="w-1/5 bg-white shadow-lg rounded-lg p-3 transition-all ease-in-out duration-300">
      <div className="flex flex-col items-center">
        <CgProfile size={50} className="text-blue-600" />
        <h2 className="mt-2 text-md font-semibold text-gray-900">PROFILE</h2>

        {/* Sidebar Menu */}
        <nav className="mt-6 space-y-3 w-full">
          <button
            onClick={() => handleSectionChange('profile')}
            className={`w-full text-left py-2 px-4 rounded-md transition-colors duration-200 ${
              activeSection === 'profile' ? 'text-blue-500 font-medium bg-blue-100' : 'text-gray-700 hover:text-blue-500 hover:bg-blue-100'
            }`}
          >
            Profile
          </button>
          <button
            onClick={() => handleSectionChange('loginDetails')}
            className={`w-full text-left py-2 px-4 rounded-md transition-colors duration-200 ${
              activeSection === 'loginDetails' ? 'text-blue-500 font-medium bg-blue-100' : 'text-gray-700 hover:text-blue-500 hover:bg-blue-100'
            }`}
          >
            Login Details
          </button>
          <button
            onClick={() => handleSectionChange('orderHistory')}
            className={`w-full text-left py-2 px-4 rounded-md transition-colors duration-200 ${
              activeSection === 'orderHistory' ? 'text-blue-500 font-medium bg-blue-100' : 'text-gray-700 hover:text-blue-500 hover:bg-blue-100'
            }`}
          >
            Order History
          </button>
          <button
            onClick={() => handleSectionChange('paymentMethods')}
            className={`w-full text-left py-2 px-4 rounded-md transition-colors duration-200 ${
              activeSection === 'paymentMethods' ? 'text-blue-500 font-medium bg-blue-100' : 'text-gray-700 hover:text-blue-500 hover:bg-blue-100'
            }`}
          >
            Payment Methods
          </button>
          <SignOut onSignOut={handleSignOut} />
        </nav>
      </div>
    </aside>
  );
};

export default ProfileSidebar;
